import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMatches, fetchMatchesDonneurOrdre, fetchMessages, fetchMessagesDonneurOrdre, selectMatch, selectMatchDonneurOrdre } from "../../redux/actions/matchActions";
import PrestataireCardLike from "../PrestataireCardLike";
import VisioTab from "../VisioTab";
import useWebSocket from "../../hooks/useWebSocket";
import { useGlobalCall } from "../../hooks/useGlobalCall";
import { setActiveTabMatch, setActiveTabMatchAppelOffre } from "../../redux/actions/dashboardActions";
import ChatConversationDonneurOrdre from "../ChatConversationDonneurOrdre";

const PrestatairesMatchesDashboardDonneurOrdre = ({ appelOffre }) => {
    const dispatch = useDispatch();
    const { matchesDonneurOrdre, selectedMatchDonneurOrdre } = useSelector((state) => state.match);
    const { token, user } = useSelector((state) => state.auth);
    const { activeTabMatchAppelOffre } = useSelector((state) => state.dashboard);
    const usersOnline = useSelector((state) => state.online.usersOnline);
    const globalCallRef = useGlobalCall();

    const handleCall = () => {
        window.dispatchEvent(new CustomEvent("setCallInfo", {
            detail: { fromUserId: user.idUser, toUserId: selectedMatchDonneurOrdre.prestataire.idUser, matchId: selectedMatchDonneurOrdre.id }
        }));
        // Lancer l'appel via le hook global
        globalCallRef.current?.();
    };

    const [activeTab, setActiveTab] = useState("prestataire");
    const wsRef = useRef(null);
    const { sendTypingStatus, addCallListener } = useWebSocket(wsRef); // initialisation du WS

    useEffect(() => {
        if (appelOffre?.idProjet) {
            dispatch(fetchMatchesDonneurOrdre(token));
        }
    }, [dispatch, token, appelOffre]);

    const containerStyle = { display: "flex", flexDirection: "column", gap: "15px", margin: "auto", alignItems:"center" };
    const listCard = { padding: "15px", border: "1px solid #ddd", borderRadius: "10px", background: "#fff", cursor: "pointer" };
    const listCardHover = { borderColor: "#007bff", boxShadow: "0 4px 12px rgba(0,0,0,0.12)" };
    const detailContainer = { border: "1px solid #ccc", borderRadius: "10px", padding: "25px", background: "#fff" };
    const detailContainerMobile = {background:"none",borderRadius:"0",border:"none",width:"100%",margin:"10px"};
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    const tabBar = {
        display: "flex",
        gap: "12px",
        marginTop: "20px",
        marginBottom: "15px",
        paddingBottom: "8px",
        overflowX: "auto",
        whiteSpace: "nowrap",
        scrollbarWidth: "none",       // Firefox
        msOverflowStyle: "none"       // IE/Edge
    };
    const tabButton = (tab) => ({
        padding: "8px 12px",
        cursor: "pointer",
        borderRadius: "6px",
        background: activeTabMatchAppelOffre === tab ? "#007bff" : "#f1f1f1",
        color: activeTabMatchAppelOffre === tab ? "white" : "#333",
        border: "none",
        flexShrink: 0,                   // IMPORTANT pour scroll horizontal
        fontSize: "14px"
    });

    const badge = (online) => ({
        display: "flex",
        alignItems: "center",
        gap: "6px",
        background: online ? "#d4f8d4" : "#f0f0f0",
        color: online ? "#258f25" : "#555",
        border: `1px solid ${online ? "#42c442" : "#aaa"}`,
        padding: "4px 8px",
        borderRadius: "6px",
        fontSize: "13px",
        margin: "auto",
        width:"fit-content"
    });

    const getActiveTabMatchName = () => {
        switch (activeTabMatchAppelOffre) {
            case "prestataire":
                return "👤 Prestataire";
            case "chat":
                return "💬 Conversation";
            case "props":
                return "🧾 Propositions";
            default:
                dispatch(setActiveTabMatchAppelOffre("prestataire"));
                return "👤 Prestataire";

        }
    }

    const prestatairesMatches = matchesDonneurOrdre.filter(m => m.projet.idProjet === appelOffre.idProjet);

    if (!selectedMatchDonneurOrdre) {
        return (
            <div style={containerStyle}>
                <h2>Prestataires matchés pour : {appelOffre.titreProjet}</h2>

                {prestatairesMatches.length === 0 && <p>Aucun prestataire matché pour ce projet.</p>}

                {prestatairesMatches.map((match) => {
                    const isOnline = usersOnline[match.prestataire.idUser] === true;
                    return (
                        <div
                            key={match.id}
                            style={listCard}
                            onClick={() => dispatch(selectMatchDonneurOrdre(match))}
                            onMouseEnter={(e) => Object.assign(e.currentTarget.style, listCardHover)}
                            onMouseLeave={(e) => Object.assign(e.currentTarget.style, listCard)}
                        >
                            <span style={badge(isOnline)}>{isOnline ? "En ligne" : "Hors ligne"}</span>
                            <h3 style={{ display: "flex", alignItems: "center" }}>
                                {match.prestataire?.raisonSocialePrestataire}

                            </h3>
                            <p style={{ opacity: 0.7 }}>{match.prestataire?.secteurActivite}</p>
                        </div>
                    );
                })}
            </div>
        );
    }

    const selectedOnline = usersOnline[selectedMatchDonneurOrdre?.prestataire?.idUser] === true;

    return (
        <div style={containerStyle}>

            <button
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    background: "#f5f5f5",
                    border: "1px solid #d4d4d4",
                    padding: "10px 16px",
                    borderRadius: "8px",
                    fontSize: "15px",
                    cursor: "pointer",
                    color: "#333",
                    width: "fit-content",
                    transition: "0.25s",
                }}
                onMouseEnter={(e) => Object.assign(e.currentTarget.style, { background: "#e4e4e4" })}
                onMouseLeave={(e) => Object.assign(e.currentTarget.style, { background: "#f5f5f5" })}
                onClick={() => dispatch(selectMatchDonneurOrdre(null))}
            >
                <span style={{ fontSize: "18px" }}>←</span>
                Retour aux prestataires
            </button>

            <div style={isMobile?detailContainerMobile:detailContainer}>
                {activeTabMatchAppelOffre !== "prestataire" &&
                    (<>
                        <span style={badge(selectedOnline)}>
                            {selectedOnline ? "En ligne" : "Hors ligne"}
                        </span>
                        <h2 style={{margin:"auto",textAlign:"center"}}>
                            {selectedMatchDonneurOrdre?.prestataire?.raisonSocialePrestataire}
                        </h2>
                    </>
                    )
                }


                <div style={{ marginTop: "20px", marginBottom: "15px" }}>
                    {isMobile ? (
                        <>
                            <button
                                style={{
                                    padding: "10px 14px",
                                    width: "100%",
                                    borderRadius: "8px",
                                    border: "1px solid #ccc",
                                    background: "#f2f2f2",
                                    fontSize: "16px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}
                                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                            >
                                {getActiveTabMatchName()}
                                <span>{isMobileMenuOpen ? "▲" : "▼"}</span>
                            </button>

                            {isMobileMenuOpen && (
                                <div style={{
                                    marginTop: "10px",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px"
                                }}>
                                    <button style={tabButton("prestataire")} onClick={() => { dispatch(setActiveTabMatchAppelOffre("prestataire")); setIsMobileMenuOpen(false); }}>👤 Prestataire</button>
                                    <button style={tabButton("chat")} onClick={() => { dispatch(setActiveTabMatchAppelOffre("chat")); setIsMobileMenuOpen(false); }}>💬 Conversation</button>

                                    {selectedOnline && (
                                        <button
                                            style={tabButton("visio")}
                                            onClick={() => { handleCall(); setIsMobileMenuOpen(false); }}
                                        >
                                            📞 Appel vidéo
                                        </button>
                                    )}

                                    <button style={tabButton("props")} onClick={() => { dispatch(setActiveTabMatchAppelOffre("props")); setIsMobileMenuOpen(false); }}>🧾 Propositions</button>
                                </div>
                            )}
                        </>
                    ) : (
                        // Version desktop normale
                        <div style={tabBar}>
                            <button style={tabButton("prestataire")} onClick={() => dispatch(setActiveTabMatchAppelOffre("prestataire"))}>👤 Prestataire</button>
                            <button style={tabButton("chat")} onClick={() => dispatch(setActiveTabMatchAppelOffre("chat"))}>💬 Conversation</button>
                            {selectedOnline && (
                                <button onClick={handleCall}>📞 Appel vidéo</button>
                            )}
                            <button style={tabButton("props")} onClick={() => dispatch(setActiveTabMatchAppelOffre("props"))}>🧾 Propositions</button>
                        </div>
                    )}
                </div>


                {activeTabMatchAppelOffre === "prestataire" && (
                    <PrestataireCardLike
                        prestataire={selectedMatchDonneurOrdre.prestataire}
                        projet={selectedMatchDonneurOrdre.projet}
                        apiUrl={process.env.REACT_APP_API_URL}
                        onLike={null}
                        onPass={null}
                        isReceivedLike={false}
                        isAlreadyMatched={true}
                    />
                )}

                {activeTabMatchAppelOffre === "chat" && (
                    <ChatConversationDonneurOrdre
                        toUserId={selectedMatchDonneurOrdre?.prestataire?.idUser}
                        onMessageSent={() => dispatch(fetchMessagesDonneurOrdre(token, selectedMatchDonneurOrdre.id))}
                    />
                )}
                {activeTabMatchAppelOffre === "visio" && (
                    <VisioTab
                        wsRef={wsRef}
                        addCallListener={addCallListener}
                        matchId={selectedMatchDonneurOrdre.id}
                        fromUserId={user.idUser}
                        toUserId={selectedMatchDonneurOrdre.prestataire.idUser}
                    />

                )}
            </div>
        </div>
    );
};

export default PrestatairesMatchesDashboardDonneurOrdre;
